import { Btn, H5, H6, LI, UL } from '../../../AbstractElements';
import React, { useState } from 'react';
import { DetailesSidebarData } from '../../../Data/KnowledegesBase';
import { Card, CardBody, CardHeader, Col, Collapse } from 'reactstrap';
import { UpcomingCourses } from '../../../Constant';
import { ChevronDown, ChevronUp } from 'react-feather';

const Sidebar2 = () => {
  const [isProfile, setisProfile] = useState(true);
  return (
    <Col xl='12'>
      <Card>
        <CardHeader>
          <H5 className='mb-0 p-0'>
            <Btn color='link accordion-icon' onClick={() => setisProfile(!isProfile)}>
              {UpcomingCourses}
              {isProfile ? <ChevronUp /> : <ChevronDown />}
            </Btn>
          </H5>
        </CardHeader>
        <Collapse isOpen={isProfile}>
          <CardBody className='upcoming-course'>
            {DetailesSidebarData.map((item) => {
              return (
                <div className='d-flex' key={item.id}>
                  <div className='flex-grow-1'>
                    <span className='f-w-600'>{item.title1}</span>
                    <H6>
                      {item.title2}
                      <a href='#javascript'>&nbsp;{item.title3}</a>
                    </H6>
                    <UL className='simple-list flex-row rating gap-1'>
                      <LI>
                        <i className='fa fa-star font-warning m-0'></i>
                      </LI>
                      <LI>
                        <i className='fa fa-star font-warning m-0'></i>
                      </LI>
                      <LI>
                        <i className='fa fa-star font-warning m-0'></i>
                      </LI>
                      <LI>
                        <i className='fa fa-star font-warning m-0'></i>
                      </LI>
                      <LI>
                        <i className='fa fa-star-half-o font-warning m-0'></i>
                      </LI>
                    </UL>
                  </div>
                  <div>
                    <H5 className='mb-0 p-0 font-primary'>{item.date}</H5>
                    <span className='d-block'>{item.month}</span>
                  </div>
                </div>
              );
            })}
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  );
};
export default Sidebar2;
